import { Injectable } from '@angular/core';
import { keys } from 'lodash';
import { TRAINING_SHAPE_COLOR } from '../../../../cross-team-shared/constants';
import { AbstractMeshService } from '../abstract-mesh.service';
import { CuboidHelper } from './cuboid-helper';

@Injectable()
export class TrainingCuboidService extends AbstractMeshService<CuboidHelper> {
  constructor() {
    super();
    this.subscribeToCuboidIds();
  }

  private subscribeToCuboidIds() {
    this.subscribeTo(
      this.renderStore('trainingShapes')('cuboids').$,
      (shapes) => {
        const shapeIds = keys(shapes).map(Number);

        this.removeHelpers();
        this.createHelpers(Array.from(shapeIds));
      },
    );
  }

  private createHelpers(indexes: number[]) {
    indexes.forEach((index) => {
      const cuboid = new CuboidHelper({
        index,
        isTraining: true,
        overrideColor: TRAINING_SHAPE_COLOR,
      });
      this.addHelper(index, cuboid);
    });
  }

  private removeHelpers() {
    this.helpers.forEach((_, key) => {
      this.removeHelper(key);
    });
  }
}
